import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ToastService } from '@isophi/core-ui';

@Injectable({
  providedIn: 'root',
})
export class HandleErrorService {
  constructor(private translocoService: TranslocoService, private toastService: ToastService) {}

  handleFormError(e: any, title: string, text: string) {
    if (typeof e.error === 'object' && Object.keys(e.error).length && e.error?.errors.length) {
      e.error?.errors.forEach((errVal: any) => {
        const camelCaseField = errVal?.field?.replace(/_([a-z])/g, (match: string, letter: string) => letter.toUpperCase());
        const errorFieldTranslated = this.translocoService.translate('registration/' + camelCaseField);
        this.toastService.error(`${errorFieldTranslated}: ${errVal.message}`, this.translocoService.translate(title));
      });
    } else if (typeof e.error === 'object' && Object.keys(e.error).length) {
      for (const error in e.error) {
        e.error[error].forEach((errVal: string) => {
          this.toastService.error(errVal, this.translocoService.translate(title));
        });
      }
    } else {
      this.toastService.error(this.translocoService.translate(text), this.translocoService.translate(title));
    }
  }
}
